/** What a review plane's marks are made of, for every editor that reads them. */
import { defaultBindingUtils, defaultShapeUtils } from "tldraw";

import { CloudShapeUtil } from "@/review/CloudShapeUtil";
import { CalloutBindingUtil } from "@/sketch/CalloutBindingUtil";
import { CalloutShapeUtil } from "@/sketch/CalloutShapeUtil";

export const REVIEW_SHAPE_UTILS = [
  ...defaultShapeUtils,
  CloudShapeUtil,
  CalloutShapeUtil,
];
export const REVIEW_BINDING_UTILS = [
  ...defaultBindingUtils,
  CalloutBindingUtil,
];
